import { useEffect, useState } from "react";
import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import LocalPrintshopIcon from "@mui/icons-material/LocalPrintshop";
import { IconButton } from "@mui/material";
import OpenInFullIcon from "@mui/icons-material/OpenInFull";
import "./App.css";
import Header from "./Components/Header/Header";
import axios from "axios";
import Loading from "./Components/Loading/Loading";
import { useMessage } from "./Components/MessageProvider/MessageProvider";
import { DatePicker, Segmented, Tooltip } from "antd";
import DetailedModal from "./Components/ProductModal/DetailedModal";
import { Link, useNavigate } from "react-router-dom";

import { Button, Dropdown } from "antd";
import { GoPlusCircle } from "react-icons/go";
import { IoFilterCircleOutline, IoPersonAddOutline } from "react-icons/io5";
import { PiHamburger } from "react-icons/pi";
import { IoDocumentTextOutline } from "react-icons/io5";
import { IoMdPerson } from "react-icons/io";
import { MdOutlineIncompleteCircle } from "react-icons/md";
import {
  TbBrandProducthunt,
  TbLayoutSidebarRightCollapseFilled,
} from "react-icons/tb";
import axiosInstance from "./Components/axiosInstance/AxiosInstance";
import { StoreProfileInfo } from "./Stores/ProfileInfo/StoreProfileInfo";

function App() {
  let { data: info } = StoreProfileInfo();
  const [data, setData] = useState(null);
  const [dataFormal, setDataFormal] = useState(null);
  const [loading, setLoading] = useState(false);
  const messageApi = useMessage();
  const elementRef = React.useRef(null);
  let [personBy, setPersonBy] = React.useState(false);
  let [dataDetail, setDataDetail] = React.useState(null);
  let [sections, setSections] = React.useState(1);
  let [openStatByModal, setOpenStatByModal] = React.useState(false);

  let getSolds = async () => {
    try {
      // setLoading(true);

      let { data } = await axiosInstance.get("/api/unofficial/total");
      if (data.success) {
        setData(data.data);
        console.log("data kocha");
        console.log(data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      // setLoading(false);
    }
  };
  let getSoldsFormal = async () => {
    try {
      // setLoading(true);

      let { data } = await axiosInstance.get("/api/official/total");
      if (data.success) {
        setDataFormal(data.data);
        console.log("data");
        console.log(data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      // setLoading(false);
    }
  };

  useEffect(() => {
    if (sections == 2) {
      getSoldsFormal();
    }
    getSolds();
  }, [sections]);

  let navigate = useNavigate();

  const items = [
    // {
    //   type: "group",
    //   key: "info",
    //   label: (
    //     <div
    //       className=" block w-[100%] flex items-center justify-start gap-2 "
    //       rel="noopener noreferrer"
    //     >
    //       <IoPersonAddOutline className="font-[18px]" />{" "}
    //       <span className="text-[18px]">{"abdunzir"}</span>
    //     </div>
    //   ),
    // },
    {
      key: "1",
      label: (
        <Link
          className=" block w-[100%] flex items-center justify-start gap-1"
          rel="noopener noreferrer"
          to="/tickets"
        >
          <IoDocumentTextOutline className="font-[30px]" />
          Ticketlar
        </Link>
      ),
    },
    {
      key: "2",
      label: (
        <Link
          className=" block w-[100%] flex items-center justify-start gap-1"
          rel="noopener noreferrer"
          to="/yukxati"
        >
          <IoDocumentTextOutline className="font-[30px]" /> Yuk xatlari
        </Link>
      ),
    },
    {
      key: "3",
      label: (
        <Link
          className=" block w-[100%] flex items-center justify-start gap-1"
          rel="noopener noreferrer"
          to="/customers"
        >
          <IoMdPerson /> Xaridorlar
        </Link>
      ),
    },
    {
      key: "4",
      label: (
        <Link
          className=" block w-[100%] flex items-center justify-start gap-1"
          rel="noopener noreferrer"
          to="/kocha"
        >
          <TbLayoutSidebarRightCollapseFilled /> Ko'cha
        </Link>
      ),
    },
    {
      key: "5",
      label: (
        <Link
          className=" block w-[100%] flex items-center justify-start gap-1"
          rel="noopener noreferrer"
          to="/kassa"
        >
          <TbBrandProducthunt /> Kassa
        </Link>
      ),
    },
    {
      key: "6",
      label: (
        <Link
          className=" block w-[100%] flex items-center justify-start gap-1"
          rel="noopener noreferrer"
          to="/products"
        >
          <TbBrandProducthunt /> Dorilar
        </Link>
      ),
    },
    {
      key: "7",
      label: (
        <div
          className=" block w-[100%] flex items-center justify-start gap-1 bg-[red-600] text-[red]"
          onClick={() => {
            localStorage.clear();
            navigate("/auth");
          }}
        >
          Chiqish
        </div>
      ),
    },
  ];

  return (
    <div className="App">
      {loading ? <Loading /> : <></>}
      <div className="max-w-[900px] m-auto w-[100%] flex  bg-[#fff] z-10 flex-row  items-center justify-between p-[10px]">
        <h2 className="bold text-[20px] upercase">
          {info?.user_info?.name ? info?.user_info?.name : "KUNLIK"}
        </h2>

        <div className="flex gap-1">
          <Dropdown
            menu={{
              items,
            }}
            placement="topRight"
            arrow
          >
            <Button>
              <PiHamburger />
            </Button>
          </Dropdown>
        </div>
      </div>

      <DetailedModal
        personBy={personBy}
        openStatByModal={openStatByModal}
        setOpenStatByModal={setOpenStatByModal}
        dataDetail={dataDetail}
      />

      <section className="flex flex-col items-center justify-center w-[100%] mt-[10px]">
        <Segmented
          size="large"
          options={["Yuk Xatari", "Ticketlar"]}
          onChange={(val) => {
            if (val == "Yuk Xatari") {
              setSections(1);
            }
            if (val == "Ticketlar") {
              setSections(2);
            }
          }}
        />

        {sections == 1 ? (
          <div className="my-5px] w-[100%] md:w-[90%] bg-[#fff] rounded-xl">
            <div className="text-[24px] my-[16px] mb-[4px] text-[#222222] font-[600] md:px-[20px]"></div>
            <div className="w-[100%] overflow ">
              <div className=" mx-auto ">
                <div className="overflow-x-auto">
                  <div className="container mx-auto p-4">
                    <h2 className="text-xl font-bold mb-4">Yukxati Chiqim</h2>
                    <table className="min-w-full bg-white border border-gray-200 rounded-lg shadow-md">
                      <thead>
                        <tr className="bg-gray-100">
                          <th className="text-left px-4 py-2 border-b">Nomi</th>
                          <th className="text-left px-4 py-2 border-b">
                            Qoldiq{" "}
                          </th>
                          <th className="text-left px-4 py-2 border-b">
                            Kunlik
                          </th>
                          <th className="text-left px-4 py-2 border-b">
                            Haftalik
                          </th>
                          <th className="text-left px-4 py-2 border-b">
                            Oylik
                          </th>
                          <th className="text-left px-4 py-2 border-b">Jami</th>
                        </tr>
                      </thead>
                      <tbody>
                        {data?.map((product, index) => (
                          <tr
                            key={index}
                            className={`${
                              index % 2 === 0 ? "bg-gray-50" : "bg-white"
                            } hover:bg-gray-100`}
                          >
                            <td className="px-4 py-2 border-b">
                              {product?.name}
                            </td>
                            <td className="px-4 py-2 border-b">
                              {product?.remains}
                            </td>
                            <td className="px-4 py-2 border-b">
                              {product?.details?.sell?.daily}
                            </td>
                            <td className="px-4 py-2 border-b">
                              {product?.details?.sell?.weekly}
                            </td>
                            <td className="px-4 py-2 border-b">
                              {product?.details?.sell?.monthly}
                            </td>
                            <td className="px-4 py-2 border-b">
                              {product?.details?.sell?.total}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  <div className="container mx-auto p-4">
                    <h2 className="text-xl font-bold mb-4">Yukxati Kirim</h2>
                    <table className="min-w-full bg-white border border-gray-200 rounded-lg shadow-md">
                      <thead>
                        <tr className="bg-gray-100">
                          <th className="text-left px-4 py-2 border-b">Nomi</th>
                          <th className="text-left px-4 py-2 border-b">
                            Qoldiq
                          </th>
                          <th className="text-left px-4 py-2 border-b">
                            Kunlik
                          </th>
                          <th className="text-left px-4 py-2 border-b">
                            Haftalik
                          </th>
                          <th className="text-left px-4 py-2 border-b">
                            Oylik
                          </th>
                          <th className="text-left px-4 py-2 border-b">Jami</th>
                        </tr>
                      </thead>
                      <tbody>
                        {data?.map((product, index) => (
                          <tr
                            key={index}
                            className={`${
                              index % 2 === 0 ? "bg-gray-50" : "bg-white"
                            } hover:bg-gray-100`}
                          >
                            <td className="px-4 py-2 border-b">
                              {product?.name}
                            </td>
                            <td className="px-4 py-2 border-b">
                              {product?.remains}
                            </td>
                            <td className="px-4 py-2 border-b">
                              {product?.details?.buy?.daily}
                            </td>
                            <td className="px-4 py-2 border-b">
                              {product?.details?.buy?.weekly}
                            </td>
                            <td className="px-4 py-2 border-b">
                              {product?.details?.buy?.monthly}
                            </td>
                            <td className="px-4 py-2 border-b">
                              {product?.details?.buy?.total}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <></>
        )}
        {sections == 2 ? (
          <div className="my-5px] w-[100%] md:w-[90%] bg-[#fff] rounded-xl">
            <div className="text-[24px] my-[16px] mb-[4px] text-[#222222] font-[600] md:px-[20px]"></div>
            <div className="w-[100%] overflow ">
              <div className=" mx-auto ">
                <div className="overflow-x-auto">
                  <div className="container mx-auto p-4">
                    <h2 className="text-xl font-bold mb-4">Ticket Chiqim</h2>
                    <table className="min-w-full bg-white border border-gray-200 rounded-lg shadow-md">
                      <thead>
                        <tr className="bg-gray-100">
                          <th className="text-left px-4 py-2 border-b">Nomi</th>
                          <th className="text-left px-4 py-2 border-b">
                            Qoldiq{" "}
                          </th>
                          <th className="text-left px-4 py-2 border-b">
                            Kunlik
                          </th>
                          <th className="text-left px-4 py-2 border-b">
                            Haftalik
                          </th>
                          <th className="text-left px-4 py-2 border-b">
                            Oylik
                          </th>
                          <th className="text-left px-4 py-2 border-b">Jami</th>
                        </tr>
                      </thead>
                      <tbody>
                        {dataFormal?.map((product, index) => (
                          <tr
                            key={index}
                            className={`${
                              index % 2 === 0 ? "bg-gray-50" : "bg-white"
                            } hover:bg-gray-100`}
                          >
                            <td className="px-4 py-2 border-b">
                              {product?.name}
                            </td>
                            <td className="px-4 py-2 border-b">
                              {product?.remains.toFixed(2)}
                            </td>
                            <td className="px-4 py-2 border-b">
                              {product?.details?.sell_official?.daily.toFixed(
                                2
                              )}
                            </td>
                            <td className="px-4 py-2 border-b">
                              {product?.details?.sell_official?.weekly.toFixed(
                                2
                              )}
                            </td>
                            <td className="px-4 py-2 border-b">
                              {product?.details?.sell_official?.monthly.toFixed(
                                2
                              )}
                            </td>
                            <td className="px-4 py-2 border-b">
                              {product?.details?.sell_official?.total.toFixed(
                                2
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  <div className="container mx-auto p-4">
                    <h2 className="text-xl font-bold mb-4">Ticket Kirim</h2>
                    <table className="min-w-full bg-white border border-gray-200 rounded-lg shadow-md">
                      <thead>
                        <tr className="bg-gray-100">
                          <th className="text-left px-4 py-2 border-b">Nomi</th>
                          <th className="text-left px-4 py-2 border-b">
                            Qoldiq
                          </th>
                          <th className="text-left px-4 py-2 border-b">
                            Kunlik
                          </th>
                          <th className="text-left px-4 py-2 border-b">
                            Haftalik
                          </th>
                          <th className="text-left px-4 py-2 border-b">
                            Oylik
                          </th>
                          <th className="text-left px-4 py-2 border-b">Jami</th>
                        </tr>
                      </thead>
                      <tbody>
                        {data?.map((product, index) => (
                          <tr
                            key={index}
                            className={`${
                              index % 2 === 0 ? "bg-gray-50" : "bg-white"
                            } hover:bg-gray-100`}
                          >
                            <td className="px-4 py-2 border-b">
                              {product?.name}
                            </td>
                            <td className="px-4 py-2 border-b">
                              {product?.remains}
                            </td>
                            <td className="px-4 py-2 border-b">
                              {product?.details?.buy?.daily}
                            </td>
                            <td className="px-4 py-2 border-b">
                              {product?.details?.buy?.weekly}
                            </td>
                            <td className="px-4 py-2 border-b">
                              {product?.details?.buy?.monthly}
                            </td>
                            <td className="px-4 py-2 border-b">
                              {product?.details?.buy?.total}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <></>
        )}
      </section>
    </div>
  );
}

export default App;
